export enum BusinessType {
    Purchase = 'Purchase',
    Redemption = 'Redemption',
    Extension = 'Extension',
    Increase = 'Increase',
    Construction = 'Construction',
    Consolidation = 'Consolidation',
    Unknown = 'Unknown'
}
